import { isValidLatitude, isValidLongitude } from '@gorila-shared-ui/components';
import { FixedMarkerOverrides, FloatingMarker } from 'baseui/map-marker';
import { memo, useEffect } from 'react';
import { Marker } from 'react-map-gl/mapbox';
import { useRecoilValue } from 'recoil';
import { useCamera } from '../../../hooks/useCamera';
import { notificationSelectedState } from '../../../storage/notifications';

function NotificationMarker() {
  const selectedNotification = useRecoilValue(notificationSelectedState);
  const { zoomTo } = useCamera();

  useEffect(() => {
    if (!selectedNotification?.latitude || !selectedNotification?.longitude) return;
    const point = {
      lng: selectedNotification.longitude,
      lat: selectedNotification.latitude,
    };
    const isValidPoint = isValidLatitude(point.lat) && isValidLongitude(point.lng);
    if (isValidPoint) {
      zoomTo(point);
    }
  }, [selectedNotification, zoomTo]);

  if (!selectedNotification?.latitude || !selectedNotification?.longitude) return null;

  const floatingMarkerOverrides: FixedMarkerOverrides = {
    Root: {
      style: () => ({
        transform: `translateY(-50%)`,
      }),
    },
  };

  const point = {
    lng: selectedNotification.longitude,
    lat: selectedNotification.latitude,
  };

  const isValidPoint = isValidLatitude(point.lat) && isValidLongitude(point.lng);

  if (!isValidPoint) return null;

  return (
    <Marker
      latitude={point.lat}
      longitude={point.lng}
    >
      <FloatingMarker
        label={selectedNotification.title}
        overrides={floatingMarkerOverrides}
        size="small"
        anchorType="circle"
      />
    </Marker>
  );
}

export default memo(NotificationMarker);
